import '../styles/PageGlobal.css';
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AdresseService } from '../services/AdresseService.js';

export default function AdresseDetailsEditPage() {
  const { type, adresse_id } = useParams();
  const navigate = useNavigate();
  
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAdresse = useCallback(async () => {
    const adresseService = new AdresseService();
    setLoading(true);
    setError(null);
    try {
      const data = await adresseService.getAdresseById(adresse_id);
      setForm({
        type: data.type,
        adresse1: data.adresse1 || '',
        adresse2: data.adresse2 || '',
        codePostal: data.codePostal || '',
        ville: data.ville || '',
        pays: data.pays || 'France',
        entityId: type === 'fournisseur' ? data.fournisseurId : data.clientId
      });
    } catch (err) {
      console.error(err);
      setError(err.message || 'Erreur lors du chargement de l\'adresse');
    } finally {
      setLoading(false);
    }
  }, [adresse_id, type]);

  useEffect(() => { fetchAdresse(); }, [fetchAdresse]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

    const handleSave = async () => {
    const adresseService = new AdresseService();
    setLoading(true);
    setError(null);

    try {
      const rawId = form.entityId;
      const parsedId = rawId ? parseInt(rawId, 10) : null;
      const finalId = isNaN(parsedId) ? null : parsedId;

      const payload = {
        id: parseInt(adresse_id, 10), //  Inclure l'ID pour éviter qu'Hibernate ne le mette à null
         type: form.type,
        adresse1: form.adresse1,
        adresse2: form.adresse2,
        codePostal: form.codePostal,
        ville: form.ville,
        pays: form.pays,
        clientId: type === 'client' ? finalId : null,
        fournisseurId: type === 'fournisseur' ? finalId : null
      };

      

      await adresseService.updateAdresse(adresse_id, payload);
      alert("Adresse modifiée avec succès !");
      navigate(-1);
    } catch (err) {
      console.error("Erreur lors de la modification :", err);
      setError(err.message || "Erreur lors de la modification");
    } finally {
      setLoading(false);
    }
  };
  if (loading) return <div>Chargement…</div>;
  if (error) return <div className="adresse-error">{error}</div>;

  return (
    <div className="containerMain adresse-form-container">
      <h1 className="adresse-form-title">
        {type === "fournisseur" ? "Détails / Modifier adresse fournisseur" : "Détails / Modifier adresse livraison client"}
      </h1>

      <div className="adresse-form">
        <div className="adresse-row">
          <label>{type === "fournisseur" ? "ID Fournisseur" : "ID Client"}</label>
          <input type="number" name="entityId" value={form.entityId || ''} onChange={handleChange} />
        </div>

        <div className="adresse-row">
          <label> Type</label>
          <input type="text" name="type" value={form.type} onChange={handleChange} />
        </div>

        <div className="adresse-row">
          <label>Rue (Adresse 1)</label>
          <input type="text" name="adresse1" value={form.adresse1} onChange={handleChange} />
        </div>

        <div className="adresse-row">
          <label>Adresse 2</label>
          <input type="text" name="adresse2" value={form.adresse2} onChange={handleChange} />
        </div>

        <div className="adresse-row">
          <label>Code Postal</label>
          <input type="text" name="codePostal" value={form.codePostal} onChange={handleChange} />
        </div>

        <div className="adresse-row">
          <label>Ville</label>
          <input type="text" name="ville" value={form.ville} onChange={handleChange} />
        </div>

        <div className="adresse-row">
          <label>Pays</label>
          <input type="text" name="pays" value={form.pays} onChange={handleChange} />
        </div>
      </div>

      <div className="adresse-footer">
        <button className="adresse-btn adresse-btn-blue" onClick={handleSave} disabled={loading}>
          {loading ? 'Sauvegarde…' : 'Sauvegarder'}
        </button>
        <button className="adresse-btn adresse-btn-grey" onClick={() => navigate(-1)} disabled={loading}>
          Annuler
        </button>
      </div>
    </div>
  );
}